import * as React from "react";

import styled from "styled-components";

import {Colors, Fonts} from "../../Styles";
import {RoundButton} from "../Buttons";
import {ArrowLeftIcon, ArrowRightIcon} from "../Icons";
import {Tooltip} from "../Tooltip/Tooltip";

interface Props {
    adviceType: "SPELL-ERROR" | "STYLE-ERROR";
    index: number;
    length: number;
    onClickNext: () => void;
    onClickPrevious: () => void;
}

export const StyledAdviceHeader = styled.h2`
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin: 0 0 10px 12px;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1.2px;

    &:before {
        position: absolute;
        top: 4px;
        left: 0;
        content: "";
        display: none;
        border-radius: 50%;
        background: ${(p: {counterColor: string}) => p.counterColor};
        width: 7px;
        height: 7px;
    }

    > span {
        background-color: ${(p: {counterColor: string}) => p.counterColor};
        color: black;
        height: 32px;
        width: 32px;
        line-height: 32px;
        border-radius: 32px;
        font-size: 18px;
        display: inline-block;
        text-align: center;
        letter-spacing: normal;
        margin: auto 0 auto 14px;
        flex-shrink: 0;
    }
`;

const HiddenTitle = styled.h1`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
`

const StyledNavigation = styled.div`
    display: flex;
    font-family: ${Fonts.theinhardt};
    font-size: 18px;
    justify-content: space-between;

    .button-navigation {
        > * + * {
            margin-left: 13px;
        }
    }
`

export const AdviceHeader = (props: Props) => (
    <React.Fragment>
        <HiddenTitle>Gefundene Fehler</HiddenTitle>
        <StyledAdviceHeader counterColor={props.adviceType === "SPELL-ERROR" ? Colors.supernova : Colors.melrose}>
            {props.adviceType === "SPELL-ERROR" ? "Rechtschreibung und Grammatik" : "Stil und Vokabular"}
        </StyledAdviceHeader>
        <StyledNavigation>
                <span>
                    <strong>{props.index + 1}</strong> / {props.length}
                </span>
            <div className="button-navigation">
                {props.index > 0 ? (
                    <Tooltip direction="west" text="vorheriger Vorschlag">
                        <RoundButton onClick={props.onClickPrevious} defaultBackground={Colors.white}>
                            <ArrowLeftIcon />
                        </RoundButton>
                    </Tooltip>) : (
                    <RoundButton disabled={true} onClick={props.onClickPrevious} defaultBackground={Colors.white}>
                        <ArrowLeftIcon />
                    </RoundButton>
                )}
                {props.index < props.length -1 ? (
                    <Tooltip direction="west" text="nächster Vorschlag">
                        <RoundButton onClick={props.onClickNext} defaultBackground={Colors.white}>
                            <ArrowRightIcon />
                        </RoundButton>
                    </Tooltip>) : (
                    <RoundButton disabled={true} onClick={props.onClickNext} defaultBackground={Colors.white}>
                        <ArrowRightIcon />
                    </RoundButton>
                )}
            </div>
        </StyledNavigation>
    </React.Fragment>
);